export const Mutations = {
  setSessionData(state, data) {
    if (data.idToken) {
      state.loggedIn = true;
      state.accessToken = data.accessToken;
      state.idToken = data.idToken;
      state.username = data.username ? data.username : localStorage.getItem('username');

      localStorage.setItem('username', state.username);
      localStorage.setItem('access_token', state.accessToken);
      localStorage.setItem('id_token', state.idToken);
    }
  },

  resetSession(state) {
    state.loggedIn = false;
    state.accessToken = null;
    state.idToken = null;
    state.username = null;
    localStorage.removeItem('username');
    localStorage.removeItem('access_token');
    localStorage.removeItem('id_token');
    localStorage.removeItem('cloudStatus');
  },

  connectToPollingMechanism(state, data) {
    state.websocketConnected = data.websocketConnected;
  },
};
